import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button as RSButton,
} from "reactstrap";

function ConfirmDeleteModal({ isOpen, toggle, banner, onConfirm, deleting }) {
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Excluir banner</ModalHeader>
      <ModalBody>
        Tem certeza que deseja excluir o banner{" "}
        <strong>{banner ? banner.title : ""}</strong>? Essa ação não pode ser
        desfeita.
      </ModalBody>
      <ModalFooter>
        <RSButton color="secondary" onClick={toggle}>
          Cancelar
        </RSButton>
        <RSButton color="danger" onClick={onConfirm} disabled={deleting}>
          {deleting ? "Excluindo..." : "Excluir"}
        </RSButton>
      </ModalFooter>
    </Modal>
  );
}

export default ConfirmDeleteModal;
